export const LabelColors = [
  '#ff1744',
  '#e04556',
  '#fc736d',
  '#ff2e93',
  '#d81b60',
  '#ad5f7d',
  '#f0982d',
  '#f7d036',
  '#bfca02',
  '#c7a57b',
  '#87564a',
  '#5d4037',
  '#8b8680',
  '#afb0a4',
  '#a5c261',
  '#00c853',
  '#4a8753',
  '#8aa177',
  '#2b6a6c',
  '#00897b',
  '#00b4b1',
  '#00acc1',
  '#109dc0',
  '#52bad5',
  '#6c99bb',
  '#166a8f',
  '#355263',
  '#004d73',
  '#3949ab',
  '#7c4dff',
];

export default LabelColors;
